import { useEffect, useState } from 'react';

type HealthReport = {
  mcp: unknown;
  ai: unknown;
  aggregator: unknown;
};

export function App() {
  const [report, setReport] = useState<HealthReport | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/health')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then(setReport)
      .catch((e: Error) => setError(e.message));
  }, []);

  const services: Array<{ name: string; key: keyof HealthReport }> = [
    { name: 'MCP', key: 'mcp' },
    { name: 'AI', key: 'ai' },
    { name: 'Aggregator', key: 'aggregator' },
  ];

  return (
    <main>
      <h1>CDIM</h1>
      {error && <p role="alert">Failed to load health: {error}</p>}
      <ul>
        {services.map((s) => (
          <li key={s.key}>
            {s.name}: <code>{report ? JSON.stringify(report[s.key]) : '…'}</code>
          </li>
        ))}
      </ul>
    </main>
  );
}
